import axios from 'axios';

// In production: REACT_APP_API_URL = https://alveofit-api.up.railway.app/api/v1
// In development: falls back to relative /api/v1 (proxied by React dev server)
const baseURL = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh token on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const refresh_token = localStorage.getItem('refresh_token');
        if (!refresh_token) throw new Error('No refresh token');
        const res = await axios.post(`${baseURL}/auth/refresh`, { refresh_token });
        const newToken = res.data.data?.access_token || res.data.access_token;
        if (newToken) {
          localStorage.setItem('access_token', newToken);
          if (res.data.data?.refresh_token) {
            localStorage.setItem('refresh_token', res.data.data.refresh_token);
          }
          original.headers.Authorization = `Bearer ${newToken}`;
          return api(original);
        }
      } catch {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
